import { useState, useEffect, useRef, useMemo } from 'react';
import { useTheme } from '@mui/material';

export default function useContainerQuery() {
  const containerRef = useRef(null);
  const theme = useTheme(); // Lấy breakpoints chuẩn từ MUI Theme
  
  // Khởi tạo state kích thước
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return;

    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        const { width, height } = entries[0].contentRect;
        // requestAnimationFrame giúp React không bị nghẽn khi resize liên tục
        window.requestAnimationFrame(() => {
          setDimensions({ width, height });
        });
      }
    });

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  // Tính toán các cờ (flags) hiển thị dựa trên chiều rộng thật của container
  const queries = useMemo(() => {
    const { width, height } = dimensions;
    const bp = theme.breakpoints.values; // { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }

    // Tránh việc chớp giao diện lúc vừa mount (width = 0)
    const isMeasured = width > 0;

    return {
      width,
      height,
      isMeasured,
      // Các cờ tương ứng với từng khoảng kích thước
      isXs: isMeasured && width < bp.sm,
      isSm: isMeasured && width >= bp.sm && width < bp.md,
      isMd: isMeasured && width >= bp.md && width < bp.lg,
      isLg: isMeasured && width >= bp.lg && width < bp.xl,
      
      // Cờ gộp (thường dùng nhất)
      isMobile: isMeasured && width < bp.sm, // Dưới 600px coi như Mobile
      isSmUp: isMeasured && width >= bp.sm,
      isMdUp: isMeasured && width >= bp.md,
      isLgUp: isMeasured && width >= bp.lg,
    };
  }, [dimensions.width, dimensions.height, theme.breakpoints.values]);

  // Trả về ref để gắn vào thẻ div, cùng với các cờ boolean
  return { containerRef, ...queries };
}